import {validatePlayerTokenAndGetPlayerInfo} from '@/api/api';
import {PlayerTokenInfo} from '@/pages/ExistingPlayerOnboarding/types';
import {useQuery} from '@tanstack/react-query';

export const useValidatePlayerTokenAndGetPlayerInfo = ({token}: {token: string}) => {
  return useQuery<PlayerTokenInfo>({
    queryKey: ['validate-player-token', token],
    queryFn: () => validatePlayerTokenAndGetPlayerInfo(token),
    enabled: !!token,
  });
};
